<template>
  <v-app>
    <v-main ref="appMain" id="appMain">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "App",
  components: {},
  data: () => ({}),
  methods: {
    ...mapActions(["getShopPreferences", "setShop", "setToken"]),
    ...mapMutations(['setThemeJson']),

    /**
     * Notify iframe change height app
     */
    iframeHeightNotify() {
      const that = this;
      const resizeObserver = new ResizeObserver(function () {
        window.parent.postMessage(
          JSON.stringify({
            type: "resize",
            data: {
              height: that.$refs.appMain.$el.scrollHeight,
            },
          }),
          "*"
        );
      });

      resizeObserver.observe(document.getElementById("appMain"));
    },
  },
  computed: {
    ...mapState(['themeJson']),
    ...mapGetters(["preferences"]),
  },
  mounted() {
    this.setShop(this.$route.query.shop);
    this.setToken(this.$route.query.token);

    this.getShopPreferences().finally(() => {
      if (this.preferences.lang) {
        this.$i18n.locale = this.preferences.lang;
      } else {
        this.$i18n.locale = "ro";
      }
      if(this.preferences.theme) {
        this.setThemeJson(this.preferences.theme);
      }
    });

    this.iframeHeightNotify();
  },
  beforeDestroy() {
    //
  },
};
</script>

<style lang="scss">
.v-application--wrap {
  min-height: inherit !important;
}
</style>
